import {
  Directive,
  OnInit,
  OnDestroy,
  Renderer2,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[ngxBraintreeDirective]',
  standalone: true,
})
export class NgxBraintreeDirective implements OnInit, OnDestroy {
  script: any;

  constructor(
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit() {
    this.script = this.renderer.createElement('script');
    this.script.type = 'text/javascript';
    this.script.src =
      'https://js.braintreegateway.com/web/dropin/1.42.0/js/dropin.js';
    if (isPlatformBrowser(this.platformId)) {
      this.renderer.appendChild(window.document.body, this.script);
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      this.renderer.removeChild(window.document.body, this.script);
    }
  }
}
